export default "<p>stamp-delete works!</p>\r\n"